import "./App.css";
import PageURL from "../src/constants/PageURL";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import AuthModule from "../src/modules/auth/AuthModule";
import ProtectedRoute from "./modules/auth/private/ProtectedRoute";
import CountryModule from "./modules/CountryModule";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { loadUser } from "./actions/userActions";
import CountryDefault from "./modules/CountryDefault";
import SpinLoader from "./components/SpinLoader";
import ProtectedAdminRoute from "./modules/auth/private/ProtectedAdminRoute";
import Login from "./modules/auth/components/Login";
import OtpComponent from "./modules/auth/components/OtpComponent";
import ResetPassword from "./modules/auth/components/ResetPassword";
import ProtectedPredictiveRoute from "./modules/auth/private/ProtectedPredictiveRoute";

function App() {
  const { user, error, loadingUser } = useSelector((state) => state.user);
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadUser());
  }, []);
  const path = location.pathname;

  const routesConfig = {
    auth: [
      { path: PageURL.BASE, element: <AuthModule /> },
      { path: PageURL.SIGN_UP, element: <AuthModule /> },
      { path: PageURL.FORGOT_PASSWORD, element: <AuthModule /> },
      {
        path: PageURL.RESET_PASSWORD,
        element: <Login children={<ResetPassword />} />,
      },
    ],
    countryModule: [
      PageURL.COUNTRYDEFAULT,
      PageURL.PROJECT_DETAILS,
      PageURL.INDIA_GEN_SUMMARY,
      PageURL.INDIA_PRES_MODEL_Loss_Flow,
      PageURL.INDIA_PRES_MODEL_Fault_Tree,
      PageURL.INDIA_PROJ_OVERVIEW,
      PageURL.INDIA_DIAGONISTIC,
      PageURL.INDIA_DIAGONISTIC_DETAILED,
      PageURL.INDIA_LOSS_FLOW,
      PageURL.INDIA_INVERTER_EFFICIENCY,
      PageURL.INDIA_INVERTER_DEVIATION,
      PageURL.SCBSMBSTRING_LOSS,
    ],
    otherProtected: [{ path: PageURL.PROJECT_ANALYTICS }],
    predictiveRoutes: [
      // Existing Predictive Routes
      {
        path: PageURL.GENERATION_SUMMARY_PREDICTIVE,
      },
      {
        path: PageURL.DIAGONISTIC_DETAILED_PREDICTIVE,
      },
      {
        path: PageURL.PREDICTIVE_SCBSMBSTRING_LOSS,
      },
      {
        path: PageURL.PREDICTIVE_INVERTER_HEATMAP_DIAGRAM,
      },

      // New Predictive Monitoring Routes
      {
        path: PageURL.PREDICTIVE_DROP_IN_PR,
      },
      {
        path: PageURL.PREDICTIVE_DC_STRING_IMBALANCE,
      },
      {
        path: PageURL.PREDICTIVE_INVERTER_AVAILABILITY,
      },
      {
        path: PageURL.PREDICTIVE_LV_AC_CABLE_LOSS,
      },
      {
        path: PageURL.PREDICTIVE_MODULE_DEGRADATION,
      },
      {
        path: PageURL.PREDICTIVE_MODULE_HOTSPOT,
      },
      {
        path: PageURL.PREDICTIVE_MOUNTING_STRUCTURE,
      },
      {
        path: PageURL.PREDICTIVE_CONNECTOR_HEATING,
      },
      {
        path: PageURL.PREDICTIVE_CABLE_INSULATION,
      },
      {
        path: PageURL.PREDICTIVE_TRANSFORMER_TEMPERATURE,
      },

      // Forecasting Route (Soiling Loss)
      {
        path: PageURL.FORECASTING_SOILING_LOSS,
      },
    ],
  };

  return (
    <>
      {loadingUser && <SpinLoader />}
      <div
        className="App"
        // onContextMenu={(e) => {
        //   if (process.env.NODE_ENV==="production") e.preventDefault();
        // }}
      >
        <ToastContainer />
        {location.pathname === PageURL.BASE && user && (
          <Navigate to="/dashboard" />
        )}

        <Routes>
          {/* Auth Routes */}
          {routesConfig.auth.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}

          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            {/* Admin Only Route */}
            <Route element={<ProtectedAdminRoute />}>
              <Route
                path={PageURL.ADMIN_DASHBOARD}
                element={<CountryModule />}
              />
            </Route>

            {/* <Route element={<ProtectedPredictiveRoute />}> */}
            {routesConfig.predictiveRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={<CountryModule />}
              />
            ))}
            {/* </Route> */}
            {/* <Route  path={PageURL.GENERATION_SUMMARY_PREDICTIVE} element={<CountryModule />} />
              <Route  path={PageURL.DIAGONISTIC_DETAILED_PREDICTIVE} element={<CountryModule />} /> */}

            {/* CountryModule Routes */}
            {routesConfig.countryModule.map((path) => (
              <Route key={path} path={path} element={<CountryModule />} />
            ))}

            {/* Other Protected Routes */}
            {routesConfig.otherProtected.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={<CountryModule />}
              />
            ))}

            {/* Conditional Route */}
            {location.pathname === PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM && (
              <Route path={path} element={<CountryModule />} />
            )}

            {/* Protected Catch-all */}
            <Route
              path="*"
              element={<Navigate to={PageURL.COUNTRYDEFAULT} />}
            />
          </Route>

          {/* Public Catch-all */}
          <Route path="*" element={<Navigate to={PageURL.BASE} />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
